module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jek8F"))).then(() => parcelRequire('5erN3'));